import type { IPlaylistItem } from "~/types";
import type { TAngle } from "~/videos/schemas/event-upload.schema";
import type { ISportAngle, TResponseSportAngle } from "~/videos/types/event-angles";
import { ANGLE_TAG_EXCLUSIONS } from "~/videos/constants/angles";

export function formatAngles(angles: TAngle[], primaryAngle: string | null): TEventAngles {
  return angles.map((angle) => ({
    name: angle.name,
    primary: angles.length > 1 ? angle.name === primaryAngle : true,
    videos: angle.files.map((item, index) => ({ index, url: item.key, duration: item.duration })),
  }));
}

export function formatSportAngle(angle: TResponseSportAngle): ISportAngle {
  return {
    name: angle.angleName ?? "",
    label: angle.label ?? "",
    shortName: angle.angleShortName ?? "",
    vsId: angle.angleVSId ?? 0,
  };
}

export function getAvailableAngleNamesFromTags(tags: IPlaylistItem[]): string[] {
  const availableAngles = new Set<string>();

  for (const tag of tags ?? []) {
    const urls = ("playlist_source" in tag ? tag?.playlist_source?.urls : undefined) as Map<string, unknown> | undefined;
    if (!(urls instanceof Map)) continue;

    for (const angleName of urls.keys()) {
      if (angleName && !(Object.values(ANGLE_TAG_EXCLUSIONS) as string[]).includes(angleName) && !availableAngles.has(angleName)) {
        availableAngles.add(angleName);
      }
    }
  }

  return Array.from(availableAngles.values());
}

export function getAngleLabelFromSportAngles(angleName: string, anglesBySportType?: ISportAngle[] | null): string {
  const match = anglesBySportType?.find((a) => a.name === angleName);
  if (match) return match.label;
  return angleName.replace(/\b\w/g, (m) => m.toUpperCase());
}
